module.exports = __webpack_public_path__ + "img/snakeGraph-rtl.b79c844b.png";